export const projects = [
  {
    projectId: 0,
    title: 'Custom Software Development',
    badges: [
      'Application Development',
      'Backend Development',
      'Cloud Computing Services',
      'Custom API Development',
      'Data Analysis and Reporting',
      'Frontend Development',
    ],
    challenge: {
      title: 'Challenge',
      description: 'A logistics company needing a custom inventory management system',
    },
    solution: {
      title: 'Sapec Solution',
      description: 'Develop a tailored software solution to streamline inventory tracking and management.',
    },
    outcome: {
      title: 'Out Come',
      description: 'Enhanced efficiency, reduced errors, and improved inventory control.',
    },
  },
  {
    projectId: 0,
    title: 'Custom Software Development',
    badges: [
      'Application Development',
      'Backend Development',
      'Cloud Computing Services',
      'Custom API Development',
      'Data Analysis and Reporting',
      'Frontend Development',
    ],
    challenge: {
      title: 'Challenge',
      description: 'A logistics company needing a custom inventory management system',
    },
    solution: {
      title: 'Sapec Solution',
      description: 'Develop a tailored software solution to streamline inventory tracking and management.',
    },
    outcome: {
      title: 'Out Come',
      description: 'Enhanced efficiency, reduced errors, and improved inventory control.',
    },
  },
  {
    projectId: 0,
    title: 'Custom Software Development',
    badges: [
      'Application Development',
      'Backend Development',
      'Cloud Computing Services',
      'Custom API Development',
      'Data Analysis and Reporting',
      'Frontend Development',
    ],
    challenge: {
      title: 'Challenge',
      description: 'A logistics company needing a custom inventory management system',
    },
    solution: {
      title: 'Sapec Solution',
      description: 'Develop a tailored software solution to streamline inventory tracking and management.',
    },
    outcome: {
      title: 'Out Come',
      description: 'Enhanced efficiency, reduced errors, and improved inventory control.',
    },
  },
  {
    projectId: 0,
    title: 'Custom Software Development',
    badges: [
      'Application Development',
      'Backend Development',
      'Cloud Computing Services',
      'Custom API Development',
      'Data Analysis and Reporting',
      'Frontend Development',
    ],
    challenge: {
      title: 'Challenge',
      description: 'A logistics company needing a custom inventory management system',
    },
    solution: {
      title: 'Sapec Solution',
      description: 'Develop a tailored software solution to streamline inventory tracking and management.',
    },
    outcome: {
      title: 'Out Come',
      description: 'Enhanced efficiency, reduced errors, and improved inventory control.',
    },
  },
];

export const particularities = [
  {
    icon: 'assets/media/icons/service-icon1.svg',
    bgColor: 'bg-info',
    title: 'Customized Software Development',
    description:
      'Sapec Software specializes in creating bespoke software solutions tailored to meet these specific industry requirements, enhancing operational efficiency and user experience.',
  },
  {
    icon: 'assets/media/icons/service-icon2.svg',
    bgColor: 'bg-warning',
    title: 'Comprehensive IT Support for Continuous Excellence',
    description:
      'With Sapec Software, you receive continuous IT support ensuring your systems are always running smoothly. Our proactive approach minimizes downtime and maximizes productivity.',
  },
  {
    icon: 'assets/media/icons/service-icon3.svg',
    bgColor: 'bg-success',
    title: 'Adherence to Industry Standards and Best Practices',
    description:
      'Sapec Software stays abreast of the latest industry standards and best practices, ensuring that your solutions are not only innovative but also compliant and reliable.',
  },
];

export const faq = [
  {
    question: 'What types of custom software development does Sapec Software offer?',
    answers: [
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.',
      'Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur tempus urna at turpis condimentum lobortis.',
    ],
  },
  {
    question: 'Does Sapec Software offer ongoing support and maintenance for its services?',
    answers: [
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.',
      'Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur tempus urna at turpis condimentum lobortis.',
    ],
  },
];

export const mockProject = [
  {
    id: 0,
    logo: 'assets/media/images/project1.svg',
    title: 'Lorem ipsum dolor sit amet',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate ',
    overview: {
      title: 'Boom Mobile',
      badges: [
        'Application Development',
        'Backend Development',
        'Cloud Computing Services',
        'Custom API Development',
        'Data Analysis and Reporting',
        'Frontend Development',
      ],
      name: {
        title: 'Project name',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra,',
      },

      shortDescription: {
        title: 'Project short description',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra,',
      },

      challenge: {
        title: 'Challenge',
        highlight: 'Lorem ipsum dolor sit amet',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra,',
      },
    },

    solution: {
      title: 'Sapec Solution',
      highlight: 'Lorem ipsum dolor sit amet',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur tempus urna at turpis condimentum lobortis. Ut commodo efficitur neque. Ut diam quam, semper iaculis condimentum ac, vestibulum eu nisl.',
    },
    outcome: {
      title: 'Outcome',
      highlight: 'Lorem ipsum dolor sit amet',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur tempus urna at turpis condimentum lobortis. Ut commodo efficitur neque. Ut diam quam, semper iaculis condimentum ac, vestibulum eu nisl.',
    },
    gallery: {
      title: 'Gallery',
      images: ['assets/media/images/gallery-img1.svg', 'assets/media/images/gallery-img1.svg', 'assets/media/images/gallery-img1.svg'],
    },
    developers: {
      title: 'Developers',
      developerIds: ['a2a4cd77-a6df-49f9-add5-63ce10702c0a', '83ee7071-3fda-454d-9f87-ed0f9a404dc2'],
    },
  },
];
